import type { PropsWithChildren } from "react";

import { ClickIdSync } from "@/features/Analytics";

export const AnalyticsProvider = ({ children }: PropsWithChildren) => {
  return (
    <>
      <ClickIdSync />
      {children}
    </>
  );
};
